<!--  -->
<template>
  <section class="">
    <div class="pay-info">
      <div class="item-cell">
        <div class="item-cell-hd">商品总额</div>
        <div class="item-cell-bd totalPrice">
          <i>&yen;</i>{{ product.Price | priceNum }}
        </div>
      </div>
      <div class="item-cell discount" v-if="product.discountAmt">
        <div class="item-cell-hd">优惠券</div>
        <div class="item-cell-bd totalPrice">
          -<i>&yen;</i>{{ product.discountAmt | priceNum }}
        </div>
      </div>
      <div class="item-cell discount" v-if="product.reduceInfo">
        <div class="item-cell-hd">促销立减</div>
        <div class="item-cell-bd totalPrice">
          -<i>&yen;</i>{{ product.reduceInfo.reducePrice | priceNum }}
        </div>
      </div>
      <div class="item-cell act-pay">
        <div class="item-cell-hd">
          <span>{{ isPendingPayment ? '待支付' : '实付款' }}</span>
        </div>
        <div class="item-cell-bd pay-num">
          <template v-if="payScore"
            ><span class="actPayMoney">{{ payScore.labelValue }}</span
            ><i class="actPayYen">积分</i></template
          >
          <template v-else
            ><i class="actPayYen">&yen;</i
            ><span class="actPayMoney">{{
              order.payPrice | priceNum
            }}</span></template
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import mixProm from '@/mixin/mixProm'

import { ORDER_MONEY_PAY_TYPE, ORDER_STATE_ENUM } from '@/config'

export default {
  mixins: [mixProm],
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    orderStatus: {
      type: Number,
      default: -1
    },
    stateDesc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ORDER_MONEY_PAY_TYPE,
      isPendingPayment: this.order.orderState == ORDER_STATE_ENUM.PENDING_PAY
    }
  },
  methods: {},
  computed: {
    ...mapState(['selectedCoupon']),
    payScore() {
      try {
        return this.order.extInfo.find(item => item.labelKey == 'payScore')
      } catch (error) {
        return null
      }
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';

.price {
  padding: 0.16rem 0 0.14rem;
  margin: rem(20px) rem(24px);
  background: #ffffff;
  border-radius: rem(16px);
  font-size: rem(26px);
  color: #262626;
  line-height: rem(32px);

  .pay-info {
    .item-cell-hd {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(32px);
    }
    .item-cell-bd {
      font-size: rem(26px);
      color: #262626;
      // line-height: rem(32px);
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.pay-num {
        display: flex;
        justify-content: flex-end;
        align-items: baseline;
      }
    }

    .item-cell {
      &:first-child {
        &::after {
          left: rem(20px);
          right: rem(20px);
        }
      }
      &.discount {
        padding-top: 0;
        // padding-bottom: 0;
      }

      &.act-pay {
        padding-top: 0;
        padding-bottom: 0.22rem;
        // i {
        //   margin-left: rem(16px);
        // }
      }
    }

    .totalPrice {
      font-weight: 500;
      color: #121212;
    }
    .actPayYen {
      font-weight: 500;
      color: #ff5900;
      margin-right: rem(2px);
    }
    .actPayMoney {
      font-weight: 500;
      color: #ff5900;
      font-size: rem(36px);
    }
  }
}
</style>
